import './App.css';
import Dictionary from "./Dictionary.js"

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <div className="App-dictionary"><span id="dict">Dictionary</span></div>
        </header>
        <main>
          {/* search in the dictionary component  -- if no word is submitted, use sunset */}
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer className="App-footer">
          <small>
            This project was coded by Adriana Pana and is {" "}
        <a href="https://github.com/AdrianaPana/dictionary-project" target="_blank" rel="noreferrer">      
        open-sourced on GitHub</a> {" "} and {" "}
        <a href="https://react-dictionary-project-app.netlify.app/" target="_blank" rel="noreferrer">hosted on Netlify</a>
          </small>
        </footer>
      </div>
    </div>
  );
}
